import { useEffect } from 'react';
import { NavigationProgress, nprogress } from '@mantine/nprogress';
import { useRouter } from 'next/router';

const RouterTransition = () => {
  const router = useRouter();

  useEffect(() => {
    const handleStart = () => nprogress.start();
    const handleComplete = () => nprogress.complete();

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', handleComplete);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleComplete);
    };
    // Subscribe once — router.events is stable. Do NOT depend on
    // router.asPath; re-subscribing mid-navigation causes the
    // routeChangeComplete handler to be detached before it fires,
    // leaving the progress bar stuck forever.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <NavigationProgress />;
};

export default RouterTransition;
